<ng-container *ngIf="text !== undefined && text !== null; else displayContraints">
  {{ text | translate }}
</ng-container>
<ng-template #displayContraints>
  <span *ngIf="maxFiles && maxFiles > 0">
    {{ 'GALAXY.UPLOADER.CONSTRAINTS.MAX_FILES_PREFIX' | translate }}
    {{ maxFiles }}
  </span>
  <span *ngIf="acceptDisplay">{{ acceptDisplay }}</span>
  <span *ngIf="maxFileSize && maxFileSize > 0">
    <span *ngIf="acceptDisplay || (maxFiles && maxFiles > 0)">.</span>
    {{ fileSizeDisplay }}
    {{ 'GALAXY.UPLOADER.CONSTRAINTS.MAX_FILE_SIZE' | translate }}
  </span>
</ng-template>
